import { render, staticRenderFns } from "./StorageFileCommands.vue?vue&type=template&id=4280d16d&scoped=true&"
import script from "./StorageFileCommands.vue?vue&type=script&lang=ts&"
export * from "./StorageFileCommands.vue?vue&type=script&lang=ts&"
import style0 from "./StorageFileCommands.vue?vue&type=style&index=0&id=4280d16d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4280d16d",
  null
  
)

export default component.exports